import { useState, useEffect } from 'react';
import './Gedichte.css';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.scrollY > 2000) { // порог 2000 пикселей
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    console.log('Scroll event listener added');
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
      console.log('Scroll event listener removed');
    };
  }, []);

  return (
    <>
      {isVisible && (
        <a
          id="scroll-to-top"
          href="#"
          title="Наверх"
          className={`scroll-to-top ${isVisible ? 'visible' : ''}`}
          onClick={(e) => {
            e.preventDefault();
            scrollToTop();
          }}
          aria-label="Прокрутить к началу страницы"
        >
          Наверх
        </a>
      )}
    </>
  );
};

export default ScrollToTop;